import {useQueryParamValue} from '@hconnect/common/query-params'
import {plantTimezonedDateRangeValidator} from '@hconnect/common/utils'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {
  AllFilterOptions,
  filterPageKeys,
  filterSettingsToUrl,
  getPageScopedFilters,
  FilterOptions,
  Page
} from '@widgets/shift-event-filters'
import {isUndefined, omit} from 'lodash'
import {useCallback, useMemo, useState} from 'react'

export const EVENT_FILTERS = 'eventsFilters'

type PageFiltersProps = [FilterOptions, (filterOptions: FilterOptions) => void]

export const usePageFilters = (
  plantId: string,
  page: Page,
  defaultFilters?: Partial<AllFilterOptions>
): PageFiltersProps => {
  const timezone = useUpmPlantTimezone(plantId)
  const keys = useMemo(() => ['timeRange', ...filterPageKeys[page]], [page])
  const [eventFilters = '', setEventFilters] = useQueryParamValue(EVENT_FILTERS, keys, {
    keepInLocalStorage: true
  })

  const [filters, setFilters] = useState<FilterOptions>(
    getPageScopedFilters(eventFilters, page, timezone, defaultFilters)
  )

  const setFilterValue = useCallback(
    (filterOptions: FilterOptions) => {
      if (Object.values(filterOptions).every(isUndefined)) {
        setEventFilters('')
        setFilters({})
        return
      }
      const filtersWithoutFreeText = omit(filterOptions, 'freeText')
      plantTimezonedDateRangeValidator(timezone, filtersWithoutFreeText.timeRange)
      setEventFilters(filterSettingsToUrl(filtersWithoutFreeText))
      setFilters(filterOptions)
    },
    [setEventFilters, timezone]
  )

  return [filters, setFilterValue]
}
